import React from 'react'
import classNames from 'classnames'

import TitleCredits from './title-credits'

class VideoBackground extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    render() {
        const {
            backgroundVideoRef,
            backgroundVideoPoster,
            textColor,
            noMargin,
            title,
            artist,
            year,
            credit,
            children
        } = this.props

        const style = {
            color: textColor,
            margin: noMargin && 'unset'
        }

        return (
            <div>
                <div className="video-background-container" style={{ margin: noMargin && 'unset' }} ref={this.domRef}>
                    <video width="1920" height="1080" src={backgroundVideoRef} poster={backgroundVideoPoster} autoplay="autoplay" loop muted />
                    <div
                        className="video-background-content darkened-background"
                        style={style}
                    >
                        {children}
                    </div>
                </div>
                {title &&
                    <TitleCredits
                        title={title}
                        artist={artist}
                        year={year}
                        credit={credit}
                    />
                }
            </div>
        )
    }
}

export default VideoBackground